import React from 'react';

import { Typography, Select, MenuItem, SelectChangeEvent } from '@mui/material';
import { Box } from '@mui/system';

type Props = {
  isLoading: boolean;
  onSave: (status: string) => void;
};

const SelectClinicNoteStatus: React.FC<Props> = ({ isLoading, onSave }) => {
  const [status, setStatus] = React.useState<string>('select');

  const handleChange = (event: SelectChangeEvent) => {
    if (event.target.value === 'select') return;
    setStatus(event.target.value as string);
    onSave(event.target.value as string);
  };

  return (
    <Box>
      <Typography fontSize={16} fontWeight={500} color='white'>
        Is this a new, established, or post-op patient?
      </Typography>

      <Select
        value={status}
        label=''
        onChange={handleChange}
        sx={{
          marginTop: '8px',
          width: '140px',
          backgroundColor: '#fff',
        }}
      >
        <MenuItem value='select' disabled>
          select
        </MenuItem>
        <MenuItem value='new'>new</MenuItem>
        <MenuItem value='established'>established</MenuItem>
        <MenuItem value='post-op'>post-op</MenuItem>
      </Select>
    </Box>
  );
};

export default SelectClinicNoteStatus;
